import React, { useContext, useState } from 'react';
import { Autocomplete, Grid, TextField, Typography } from '@mui/material';
import Required from './required';
import contactStyles from "./../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss";
import popupStyles from "./../../assets/styles/componentStyles/globalPopupStyles.module.scss";
import styles from "./../../assets/styles/componentStyles/userProfileStyles/userProfileStyle.module.scss";
import { UserContext, UserContextPayload } from '../../context/userContext';
import { GenericDataContext, GenericDataContextPayload } from '../../context/genericDataContext';
import { timezoneList } from '../../models/axiosModel';
import agent from '../../services/api';
import { useGenericStore } from '../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';

interface EditUserTimezonePopupProps {
    renderButton: (text: string, onClick: () => void, className: string | undefined, width: string, disabled?: boolean) => JSX.Element;
    onCancel: () => void;
}

const EditUserTimezonePopup: React.FC<EditUserTimezonePopupProps> = ({ renderButton, onCancel }) => {
    const { userDetail, setUserDetail, setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload;
    const { genericTimezoneList } = useContext(GenericDataContext) as GenericDataContextPayload;
    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })));

    const [selectedTimezone, setSelectedTimezone] = useState<timezoneList | null>(
        genericTimezoneList.find((timezone) => timezone.timezone_id === userDetail?.timezone_id) ?? null
    );

    const isSaveDisabled = () => {
        if (!selectedTimezone) {
            return true;
        }
        return selectedTimezone.timezone_id === userDetail?.timezone_id;
    };

    const onClickOfSave = async () => {
        if (!selectedTimezone) {
            return;
        }

        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        try {
            const payload = {
                timezone_id: selectedTimezone.timezone_id
            };
            const response = await agent.updateUserTimezone.put(payload);
            if (!response.status) {
                handleError(response);
            } else {
                showSuccess("Timezone updated Successfully!");
                setUserDetail((prev) => ({
                    ...prev,
                    timezone_id: selectedTimezone.timezone_id,
                    timezone_hour: selectedTimezone.timezone_hour,
                    timezone_name: selectedTimezone.timezone_name,
                    timezone_standard_name: selectedTimezone.timezone_standard_name,
                }));
                onCancel();
            }
        } finally {
            setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
        }
    };

    return (
        <>
            <Grid item xs={12}>
                <Grid container direction="column">
                    <Grid item mb={1}>
                        <Typography className={popupStyles.popupFieldTypography}>
                            Timezone Name <Required />
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Autocomplete
                            className={contactStyles.contactFilterDropdownsInPopup}
                            options={genericTimezoneList}
                            getOptionLabel={(option) => option.timezone_name}
                            isOptionEqualToValue={(option, value) => option.timezone_id === value.timezone_id}
                            value={selectedTimezone}
                            onChange={(_, value) => setSelectedTimezone(value)}
                            ListboxProps={{
                                className: styles.timezoneAutocompleteListbox,
                            }}
                            renderInput={(params) => (
                                <TextField {...params} placeholder="Select Timezone" />
                            )}
                        />
                    </Grid>
                </Grid>
            </Grid>

            <Grid item xs={12} mt={2}>
                <Grid container gap="12px" direction="row" flexWrap="nowrap" justifyContent="center">
                    {renderButton("Cancel", onCancel, 'borderedButtonStyle', "130px")}
                    {renderButton("Save", onClickOfSave, 'primaryButtonStyle', "130px", isSaveDisabled())}
                </Grid>
            </Grid>
        </>
    );
};

export default EditUserTimezonePopup;
